// class
import PadDiagnostic from 'app/redux/reducers/pad-creator/components-js/pad-diagnostic/PadDiagnostic';

const TEMPLATE_NAME = 'PAD_CREATOR_DIAGNOSTIC';

const initialState = () => ({
  loading: false,
  errors: [],
  data: {
    loaded: [],
    screen: [],
    submit: []
  }
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }

    case `${TEMPLATE_NAME}_REJECTED`: {
      const errors = [...action.payload];

      return {
        ...state,
        loading: false,
        errors
      };
    }

    case `${TEMPLATE_NAME}_FULFILLED`: {
      const newData = action.payload;

      const { padDiagnostics /* , padDiagnosticCIDs */ } = newData;

      const padDiagnostic = new PadDiagnostic(state);

      // prettier-ignore
      return padDiagnostic
        .prepare(padDiagnostics)
        .setLoading(false)
        .getState();
    }

    case `${TEMPLATE_NAME}_ADD`: {
      const { data: padDiagnostic } = action.payload;

      return new PadDiagnostic(state).add(padDiagnostic).setLoading(false).getState();
    }

    case `${TEMPLATE_NAME}_EDIT`: {
      const newData = action.payload;
      const padVisit = { ...newData.data };

      return new PadDiagnostic(state).edit(padVisit).setLoading(false).getState();
    }

    case `${TEMPLATE_NAME}_REMOVE`: {
      const newData = action.payload;
      const padVisit = newData.data;

      return new PadDiagnostic(state).remove(padVisit).setLoading(false).getState();
    }

    // case `${TEMPLATE_NAME}_SUSPEND`: {
    //   const newData = action.payload;
    //   const padVisit = newData.data;

    //   return new PadDiagnostic(state).suspend(padVisit).setLoading(false).getState();
    // }

    // case `${TEMPLATE_NAME}_UNSUSPEND`: {
    //   const newData = action.payload;
    //   const padVisit = newData.data;

    //   return new PadDiagnostic(state).unsuspend(padVisit).setLoading(false).getState();
    // }

    case `${TEMPLATE_NAME}_FOLLOW_PAD_MODEL`: {
      const newData = action.payload;
      const padVisit = newData.data;

      return new PadDiagnostic(state).followPadVisitModel(padVisit).setLoading(false).getState();
    }

    case `${TEMPLATE_NAME}_RESET`: {
      return initialState();
    }

    default:
      return state;
  }
};

export default reducer;
